import { LOTTO_REDUCER } from '../constants';
import { useCustomSelector } from './useCustomSelector';

import { TLottoSelector, TEqualityFunction } from '../types';

export const useLottoSelector =
    <TSelected>(selector: TLottoSelector<TSelected>, equalityFn?: TEqualityFunction<TSelected>) =>
        useCustomSelector<TSelected, typeof LOTTO_REDUCER>(LOTTO_REDUCER, selector, equalityFn);
